export default __webpack_public_path__ + "static/0156-540c265d96ad8cd18f9b7d3f4c2758dc.png";